// src/components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-container">
          <div>
            <div className="footer-logo">AgroVacina</div>
            <p>Solução completa em rastreabilidade e vacinação digital para equinos e bovinos. Tecnologia que valoriza o produtor e cuida do rebanho.</p>
            <div className="footer-badge">
              <i className="fas fa-trophy"></i>
              Semifinalista do Desafio Liga Jovem Sebrae — Maranhão
            </div>
          </div>

          <div>
            <h3>Links Rápidos</h3>
            <a href="#inicio" className="footer-link">Início</a>
            <a href="#video-mvp" className="footer-link">MVP</a>
            <a href="#conquista" className="footer-link">Conquista</a>
            <a href="#problema" className="footer-link">Problema</a>
            <a href="#solucao" className="footer-link">Solução</a>
            <a href="#planos" className="footer-link">Planos</a>
            <a href="#galeria" className="footer-link">Galeria</a>
            <a href="#equipe" className="footer-link">Equipe</a>
          </div>
          
          <div>
            <h3>Mais Informações</h3>
            <a href="#validacoes" className="footer-link">Validações</a>
            <a href="#contato" className="footer-link">Contato</a>
          </div>
          
          <div>
            <h3>Contato</h3>
            <p>(86) 99482-2589</p>
            <p>agrovacina@gmail.com</p>
          </div>
        </div>
        
        <div className="copyright">
          © 2025 AgroVacina. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;